import { Component, Inject, inject } from '@angular/core';

import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { SensitivityLabelService } from '../../../../../services/sensitivity-label.service';

@Component({
  selector: 'app-prompt-library-list-item-summary',
  imports: [
    MatListModule,
    MatIconModule,
    MatChipsModule
],
  templateUrl: './prompt-library-list-item-summary.component.html',
  styleUrl: './prompt-library-list-item-summary.component.scss'
})
export class PromptLibraryListItemSummaryComponent {
  name: string = '';
  description: string = '';
  keywords: string = '';
  model: string = '';
  temperature: number = 0;
  topP: number = 0;
  prompt: string = '';
  type: string = '';
  sensitivityLabels: any[] = [];
  users: any[] = [];
  owners: any[] | '' = [];
  groups: any[] | '' = [];
  fileUploadLabel: string = '';
  collectInfoLabel: string = '';
  isUniversal: boolean = false;
  isEnabled: boolean = false;
  agent?: string;
  instructions?: string[] = [];
  
  #bottomSheetRef = inject<MatBottomSheetRef<PromptLibraryListItemSummaryComponent>>(MatBottomSheetRef);

  #sensitivityLabelService = inject(SensitivityLabelService);
  /** Whether the sensitivity-label feature is enabled; label rows are hidden when disabled. */
  readonly slEnabled = this.#sensitivityLabelService.enabled;

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: {
    meta: {
      name: string;
      description: string;
      keywords: string;
      topP?: number;
      temperature?: number;
      model?: string;
      prompt?: string;
      type?: string;
      fileUploadLabel?: string;
      collectInfoLabel?: string;
      sensitivityLabels?: any[];
      users?: any[];
      owners: any[];
      groups: any[];
      isUniversal?: boolean;
      isEnabled?: boolean;
      agent?: string;
      instructions?: string[];
    }
  }) {
    this.name = data.meta.name || '';
    this.description = data.meta.description || '';
    this.keywords = data.meta.keywords || '';
    this.topP = data.meta.topP || 0;
    this.temperature = data.meta.temperature || 0;
    this.model = data.meta.model || '';
    this.prompt = data.meta.prompt || '';
    this.type = data.meta.type || '';
    this.fileUploadLabel = data.meta.fileUploadLabel || '';
    this.collectInfoLabel = data.meta.collectInfoLabel || '';
    this.sensitivityLabels = data.meta.sensitivityLabels || [];
    this.users = data.meta.users || [];
    this.owners = data.meta.owners || '';
    this.groups = data.meta.groups || '';
    this.isUniversal = data.meta.isUniversal || false;
    this.isEnabled = data.meta.isEnabled || false;
    this.agent = data.meta.agent;
    this.instructions = data.meta.instructions || [];
  }

  closeNotification(event: MouseEvent): void {
    this.#bottomSheetRef.dismiss();
    event.preventDefault();
  }

  /**
   * Resolves a stored thin sensitivity-label reference (`{ code }`) to its human-readable
   * display name. Stored labels no longer carry `label`/`name`, so the display text is
   * looked up from the registered label list. Falls back to the raw code when unresolved.
   */
  resolveLabelName(label: { code?: string; label?: string }): string {
    return this.#sensitivityLabelService.resolve(label)?.name ?? label?.label ?? label?.code ?? '';
  }
}
